import React from 'react';
import { Row, Col } from 'antd';
import { TaskItem } from '../TaskItem';
import { Task } from '@/components/ActionPlan/types';

type TaskListProps = {
	value: Task[];
	users: {
		value: string;
		label: string;
	}[];
}

export function TaskList({ value = [], users }: Readonly<TaskListProps>): JSX.Element {
	
	return (
		<Row gutter={[0, 15]}>
			{value.map(
				(task: Task, index: number) =>
					<Col key={index} span={24}>
						<TaskItem index={index} data={task} users={users} />
					</Col>
			)}
		</Row>
	);
}
